var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { cardProgramIsGatewayIssuingEnabled, isGatewayCardOrProgram } from '@Utils/gatewayCards';
import { keyBy } from 'lodash';
import { toast } from 'react-toastify';
import { AddUserConnectedSubaccountModalConnected } from '@ReactComponents/AdminSettings/Components/CardPrograms/AddUserConnectedSubaccountModal/AddUserConnectedSubaccountModal';
import { DeleteCardProgramConfirmModal } from '@ReactComponents/AdminSettings/Components/CardPrograms/DeleteCardProgramConfirmModal';
import { RenameCardModal } from '@ReactComponents/AdminSettings/Components/CardPrograms/RenameCardModal';
import { SuspendCardProgramConfirmModal } from '@ReactComponents/AdminSettings/Components/CardPrograms/SuspendCardProgramConfirmModal';
import { ManageCardProgramModal } from '@ReactComponents/AdminSettings/Components/ManageCardProgram';
import { CardsGatewayIssuingModalConnected } from '@ReactComponents/Cards/CardsGatewayIssuingModal/CardsGatewayIssuingModal';
import { ManualUploadCardProgramModal } from '@ReactComponents/ManualUploadCardProgramModal';
import { LinkedAccountsApiService } from '@ClientApi/linkedAccounts';
import { ADD_CAPABILITIES, ADD_CARD_PROGRAM, CARDS_SET_LOADING, CARD_PROGRAMS_SET_LOADING, REMOVE_CARD_PROGRAM, SET_CARDS, SET_CARDS_SEARCH_PARAMS, SET_CARD_PROGRAM, SET_CARD_PROGRAMS, SET_CARD_PROGRAM_CARD_COUNTS } from './cardsActionsConstants';
import { getExpenseBucketsForUser } from './expenseBucketsWithTagsActions';
import { ShowModal } from './modalActions';
export class SetCardPrograms {
    constructor(cardPrograms) {
        this.type = SET_CARD_PROGRAMS;
        this.payload = cardPrograms;
    }
}
export class AddCardProgram {
    constructor(cardProgram) {
        this.type = ADD_CARD_PROGRAM;
        this.payload = cardProgram;
    }
}
export class SetCardProgram {
    constructor(cardProgram) {
        this.type = SET_CARD_PROGRAM;
        this.payload = cardProgram;
    }
}
export class SetCards {
    constructor(cards, total, paginationParams) {
        this.type = SET_CARDS;
        this.payload = { cards, total, paginationParams };
    }
}
export class RemoveCardProgram {
    constructor(id) {
        this.type = REMOVE_CARD_PROGRAM;
        this.payload = id;
    }
}
export class SetCardProgramCardCounts {
    constructor(counts) {
        this.type = SET_CARD_PROGRAM_CARD_COUNTS;
        this.payload = counts;
    }
}
export class AddCapabilities {
    constructor(capabilities) {
        this.type = ADD_CAPABILITIES;
        this.payload = capabilities;
    }
}
export class SetCardsSearchParams {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_CARDS_SEARCH_PARAMS;
    }
}
export class SetLoading {
    constructor(loading) {
        this.type = CARD_PROGRAMS_SET_LOADING;
        this.payload = loading;
    }
}
export class SetCardsLoading {
    constructor(loading) {
        this.type = CARDS_SET_LOADING;
        this.payload = loading;
    }
}
export const init = (includeSubaccounts = true) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetLoading(true));
    const programsPromise = LinkedAccountsApiService.getCompanyCardPrograms({
        overrideStore: true,
        onlyPending: false,
        includeStatementCycle: true,
        includeSubaccounts: includeSubaccounts
    });
    const programCardCountsPromise = LinkedAccountsApiService.getProgramCardCounts();
    const capabilitiesPromise = LinkedAccountsApiService.getGatewayProgramsCapabilities();
    const [programs, counts, capabilities] = yield Promise.all([programsPromise, programCardCountsPromise, capabilitiesPromise]);
    dispatch(new AddCapabilities(keyBy(capabilities, 'programId')));
    dispatch(new SetCardPrograms(programs));
    dispatch(new SetCardProgramCardCounts(counts));
    dispatch(new SetLoading(false));
});
export const getCards = (parentLinkedAccountId, { page, pageSize, sortField, sortDirection, filters, search }, { includeSharedLink = false, includeUnexpensedTransactionCount = false, types = null }) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new SetCardsLoading(true));
    const defaultFilters = {
        state: ['active'],
        connected_to: null
    };
    const updatedFilters = Object.assign(Object.assign({}, defaultFilters), filters);
    const requestSearchParams = {
        parentLinkedAccountId,
        page,
        pageSize,
        sortField,
        sortDirection,
        search,
        includeSharedLink,
        includeUnexpensedTransactionCount,
        filters: updatedFilters
    };
    dispatch(new SetCardsSearchParams(requestSearchParams));
    const cards = yield LinkedAccountsApiService.searchCardsForProgram(parentLinkedAccountId, pageSize, page * pageSize, sortField, sortDirection, updatedFilters, search, true, includeSharedLink, includeUnexpensedTransactionCount, types);
    const { searchParams } = getState().cards;
    if (requestSearchParams !== searchParams) {
        return;
    }
    const uniqueUserIds = new Set();
    cards.rows.forEach(({ user_id }) => uniqueUserIds.add(user_id));
    const expenseBucketPromises = [];
    const expenseBucketsByUser = getState().expenseBucketsWithTags.expenseBucketsByUser;
    for (const userId of uniqueUserIds) {
        if (!expenseBucketsByUser[userId]) {
            expenseBucketPromises.push(dispatch(getExpenseBucketsForUser(userId)));
        }
    }
    yield Promise.all(expenseBucketPromises);
    dispatch(new SetCards(cards.rows, cards.count, {
        page,
        pageSize,
        sortField,
        sortDirection,
        filters: updatedFilters,
        search
    }));
    dispatch(new SetCardsLoading(false));
});
export const newCard = (dispatch, openIssueCardDrawer, capabilities) => (program) => __awaiter(void 0, void 0, void 0, function* () {
    if (isGatewayCardOrProgram(program)) {
        const programCapabilities = capabilities[program.id];
        if (cardProgramIsGatewayIssuingEnabled(program, programCapabilities)) {
            if (window.FEATURES.card_request_management) {
                return openIssueCardDrawer(program);
            }
            dispatch(new ShowModal(CardsGatewayIssuingModalConnected, {
                capabilities: programCapabilities,
                parentLinkedAccountId: program.id,
                institutionName: program.institution_name,
                onSubmit: () => { }
            }));
        }
    }
});
export const suspendProgram = (dispatch) => (program) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new ShowModal(SuspendCardProgramConfirmModal, {
        program,
        onSuspend: () => __awaiter(void 0, void 0, void 0, function* () {
            dispatch(new SetLoading(true));
            const updatedProgram = yield LinkedAccountsApiService.suspendProgram(program.id);
            dispatch(new SetCardProgram(updatedProgram));
            dispatch(new SetLoading(false));
        })
    }));
});
export const deleteProgram = (dispatch, counts) => (program) => __awaiter(void 0, void 0, void 0, function* () {
    let cardCount = 0;
    if (counts[program.id]) {
        const { assigned, unassigned } = counts[program.id];
        cardCount = assigned + unassigned;
    }
    dispatch(new ShowModal(DeleteCardProgramConfirmModal, {
        program,
        cardCount,
        onDelete: () => __awaiter(void 0, void 0, void 0, function* () {
            dispatch(new SetLoading(true));
            yield LinkedAccountsApiService.deleteProgram(program.id);
            dispatch(new RemoveCardProgram(program.id));
            dispatch(new SetLoading(false));
        })
    }));
});
export const uploadTransactions = (dispatch) => (program) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(new ShowModal(ManualUploadCardProgramModal, {
        cardProgram: program,
        firstPanel: 'start',
        onSuccess: () => toast.success(`Transactions uploaded.`),
        onFailure: (message) => toast.error(message || 'Something went wrong; Some updates may not have applied.')
    }));
});
export const addCards = (dispatch) => (programId) => __awaiter(void 0, void 0, void 0, function* () {
    const setAllCards = () => dispatch(init());
    dispatch(new ShowModal(AddUserConnectedSubaccountModalConnected, {
        linkedAccountId: programId,
        onCardAdded: setAllCards
    }));
});
export const updateStatementDate = (dispatch) => (programId, data) => __awaiter(void 0, void 0, void 0, function* () {
    const updatedProgram = yield LinkedAccountsApiService.updateCardProgramStatementDate(programId, data);
    dispatch(new SetCardProgram(updatedProgram));
});
export const manageCards = (dispatch) => (cards, users) => {
    const setAllCards = () => dispatch(init());
    dispatch(new ShowModal(ManageCardProgramModal, {
        cards,
        users,
        cardsUpdated: setAllCards,
        transactionsBulkSkipped: setAllCards
    }));
};
export const renameCard = (dispatch) => (card) => {
    dispatch(new ShowModal(RenameCardModal, {
        card,
        onEdit: (newName) => __awaiter(void 0, void 0, void 0, function* () {
            const updatedProgram = yield LinkedAccountsApiService.updateCardProgramName(card.id, newName);
            dispatch(new SetCardProgram(updatedProgram));
        })
    }));
};
